const lang={
  xzdq:'Select Region',
  db:'UAE',
  db1:'Dubai',
  tg:'Taiwan Securities',
  rg:'Japan Securities',
  azg:'Australia Securities',
  mlxyg:'Malaysia Securities',
  tgg:'Thailand Securities',
  flbg:'Philippines Securities',
  yng:'Indonesia Securities',
  xjp_g:'Singapore Securities',
  m_g:'US Securities',
  gzjq:'Market Holiday',
  xgsc:'Hong Kong Market',
  xgscs:'Hong Kong',
  mgsc:'U.S. Market',
  xjps:'Singapore',
  mgscs:'U.S.',
  china:'China Holiday',
  chinas:'China',
  xjp:'Singapore Holiday',
  xjp:'Singapore',
  ja:'Japan Holiday',
  az:'Australia Holiday',
  tw:'Taiwan Holiday',
  d_g:'Germany Securities',
  dg:'Germany',
  ml:'Malaysia Holiday',
  china_c:'China',
  xjp_c:'Singapore',
  ja_c:'Japan',
  az_c:'Australia',
  tw_c:'Taiwan',
  ml_c:'Malaysia',
  xg:'Hong Kong',
  am:'U.S.',
  grzh:'Individual Account',
  gszh:'Corporate Account',
  wtlb:'Problem category',
  sswt:'Search questions',
  yhmc:'Bank Name',
  zhhm:'Account Number / Type of Currency',
  swif:'SWIFT Code',
  addre:'Branch Address',
  zhmc:'Account Name',//Account name
  xggp:'Hong Kong Securities',
  scjs:'Market Introduction',
  jyfs:'Trading Information',
  fwsf:'Services Fees',
  jytg:'Trading Announcement',
  jytgs:'Latest Announcements',
  gstg:'Company notice',
  jtzb:'Group headquarters',
  lxwm:'Contact us',
  ybcx:'General query',
  jyrx:'Transaction Hotline',
  mfndzx:'Free mainland special line',
  cz:'Fax',
  dy:'Email',
  bgsj:'Office hours',
  dtime:'9:00 am - 6:00 PM closed on Saturdays, Sundays and Hong Kong Public Holidays',
  zcgl:'Asset Management',
  glfw:'Management services',
  tzcl:'​​Investment Strategy',
  qmiswx:'QMIS Official WeChat',
  homes:'Home / Global Stocks',
  b_fimg:require('@/image/home/alld_en.png'),
  getimage:require('@/image/home/getimage_en.png'),
  hongd_img:require('@/image/honggu/downimg_en.png'),
  rq_date:'Date',
  rq_biaoti:'Announcement',
  hongd_img_model:require('@/image/home_model/downimg_en.png'),
  getimagemodel:require('@/image/home_model/get_en.png'),
  mzsm:'Disclaimer',
  qmisyeas:'© 2021 QMIS Financial Group',
  agree:'Agree',
  an_ree:'Disagree',
  Android:require('@/image/home/Android.png'),
  Android_s:require('@/image/home_s/Android.png'),
  mod_and:require('@/image/home_model/Android_en.png'),
  inSearch:'Search',
  isBack:'Back',
  jjfw:'Fund Services',
  jjcp:'Fund Products',
  mggp:'US Securities',
  xgrg:'IPO Subscriptions',
  xgrl:'IPO Calendar',
  xjpg:'Singapore Securities',
  malxy:'Malaysia Securities',
  aozg:'Australia Securities',
  jagu:'Japan Securities',
  twstk:'Taiwan Securities',
  slgt:'Stock Connect',
  zqfw:'Bond Services',
  gpzc:'Stock Transfer',
  klzh:'Account Opening',
  tckx:'Deposit & Withdrawal',
  qlkh:'Securities Trading',
  ydkh:'Sent By Post',
  yykh:'Appointment',
  zxkh:'Account Opening APP',
  wskh:'Account Opening Online',
  sjfw:'Market Data Service',
  zjcq:'Deposit & Withdrawal',
  bgxz:'Download Form',
  SecuritiesTrading:'Securities Trading',
  AssetManagement:'Asset Management',
  cjwt:'FAQs',
  cn_login:'Online Trading',
  nYeat:'',//year
  ystk:'Privacy Data Policy',
  fxpl:'Risk Disclosure Statement',
  tkxz:'Terms & Conditions',
  clj:'Hyperlink Policy',
  aqts:'Security Tips & Advice',
  grsm:'Personal Data Collection Statement',
  ywjj:'Introduction',
  cpfw:'Products & Services',
  zsw:'There are no results matching your search "',
  cxss:'". Please search again.',
  ssjy:'Here are our search suggestions',
  y1:'Please check if your spelling is correct',
  y2:'Try more general words or fewer words',
  y3:'Try different keywords or synonyms',
  alb:'Search by category',
  Alert:'Fraudulent Alert',
  bew:'Beware of Fraudsters Posing as QMIS Financial Group',
  ithas:'It has come to our attention that fraudsters pose as QMIS Financial Group (the “Group”) to ask for the personal particulars and deposit money into their bank accounts in return for earning the commission under their fraudulent recruitment exercise.',
  ithas1:'The Group hereby advise you that the aforesaid fraudulent activities shall have nothing to do with the Group, nor any of its subsidiaries (including but not limited to QMIS Securities Limited and QMIS Asset Management Limited). You are further reminded not to make any payments to any third parties and disclose any sensitive information about yourselves and your bank accounts details.',
  ithas2:'Should you require any assistance, please report to the Police Station immediately or contact the 24-hour Anti-Scam Helpline of Anti-Deception Coordination Centre at 18222.',
  ithas3:'',
  qgp:'QMIS Financial Group',
  dapas:'11 March 2022',
  yuedu:'Read',

  zgdl: "China",
  zgxg: "Hong Kong,China",
  zgam: "Macau,China",
  adly: "Australia",
  jnd: "Canada",
  mlxy: "Malaysia",
  mg: "USA",
  xjp1: "Singapore",
  xxl: "New Zealand",
  yg: "UK",


  title_1:'Account Opening Appointment',
  title_2:'Thank you for using QMIS Securities account opening appointment service. Our staff will contact you to confirm the appointment details upon submission. Should you have any enquiries, please call our Customer Service Hotline (852) 3971 6919 or visit our headquarters.',
  title_3:'Personal Information',
  zwmc_yy:'English Name',
  cw_yy:'Title',
  dydz_yy:'Email Address',
  lldh_yy:'Telephone Number',

  title_4:'Appointment Details',
  yyrq_yy:'Appointment date',
  yysj_yy:'Appointment Time',
  yzm_yy:'Code',
  dj_yy:'Submit',


  jjlx:'Fund Type：',
  jjjs:'Fund Services Introduction',
  jxrg:'Subscription',
  qbjjlb:'All Fund Type',
  hhzczj:'Mutual Fund',
  jjzdzj:'Fund of Funds',
  hbsczj:'Money Market Fund',
  qhzj:'Balanced Fund',
  dxzj:'Fixed Income Fund',
  gpzj:'Equity Fund',
  zszj:'Index Fund',
  llzj:'Alternative Investment Fund',

  jjbh:'Product Code',
  jjmc:'Product Name',
  jjhb:'Currency',
  jjclr:'Issue Date',
  ljbx:'Cumulative Performance',
  jjlb:'Product Type',
  fxpj:'Risk Rating',
  rg_buy:'Buy',
  nodata:'There are currently no Fund Products available for subscription.',
  nodata1:'There are currently no Bond Products available for subscription.',

  zqlx:'Bond Type：',
  gjbh:' Product Code',
  zqfxr:'Product Name',
  zqhb:'Currency',
  pxpl:'Coupon Frequency',
  ndpx:'Coupon Rate',
  zqlb:'Product Type',
  synq:'Remaining Period',
  zqjs:'Bond Introduction',
  zqcp:'Bond Products',
  syzqlx:'All Bond Type',
  zqzq:'Sovereign Bond',
  qyzh:'Corporate Bond',
  zzqzq:'Quasi Sovereign',
  jzdbzq:'Asset-Backed Security',
  gsyqyzq:'High Yield Bonds',

  jjrg:'Fund Subscription',
  zqrg:'Bond Subscription',
  zqzh:'Securities Account',
  yhdh:'Phone Number',
  sbm:'Verification Code',
  tj:'Submit',

  month_text:' Month',
  months_text:' Months',

  wt1:'Please select your "Age Group":',
  wt2:'Please state your "Highest Education Level":',
  wt3:'Please state your "Total Net Assets":',
  wt4:'Please state your "Employment Status":',
  wt5:'Whether you are classified as a ',
  wt5_11:'"Vulnerable Client"',
  wt6:'Do you have any general knowledge of "Derivatives and Structured Products" ?',
  wt7:'Do you have any relevant experience in "Investing in Fund Product(s)" ?',
  wt8:'Do you have any relevant experience in "Investing in Bond Product(s)" ?',
  wt9:'Whether you are classified as an ',
  wt9_11:'"Individual Professional Investor"',
  
  wt1_1:'A. 18 to 24',
  wt1_2:'B. 25 to 39',
  wt1_3:'C. 40 to 54',
  wt1_4:'D. 55 to 64',
  wt1_5:'E. 65 or above',

  wt2_1:'A. Not Applicable',
  wt2_2:'B. Primary or below',
  wt2_3:'C. Secondary or Post-Secondary',
  wt2_4:'D. University or above/Professional Qualification (on Financial Related Disciplines)',
  wt2_5:'E. University or above/Professional Qualification (on Non-Financial Related Disciplines)',

  wt3_1:'A. Below HK$500,000',
  wt3_2:'B. HK$500,000 to HK$999,999',
  wt3_3:'C. HK$1,000,000 to HK$4,999,999',
  wt3_4:'D. HK$5,000,000 to HK$7,999,999',
  wt3_5:'E. HK$8,000,000 or above',

  wt4_1:'A. Self-Employed',
  wt4_2:'B. Full-Time Employment',
  wt4_3:'C. Part-Time Employment',
  wt4_4:'D. Unemployment',
  wt4_5:'E. Retired',

  wt5_1:'A. YES',
  wt5_2:'B. NO',

  wt6_1:'A. YES',
  wt6_2:'B. NO',
  wt6_3:'Your acquire general knowledge mean :',
  wt6_4:'A. Undergoing relevant training or attending courses or seminars on "Derivatives and Structured Products"',
  wt6_5:'B. Current employment and/or previous work experience for which relates / related to "Derivatives and Structured Products"',
  wt6_6:'C. Client have at least 5 transactions of "Derivatives and Structured Products" in recent 3 years investment experience',

  wt7_1:'A. YES',
  wt7_2:'B. NO',
  wt7_3:'If so, have you ever invested in the following "Fund Types"? (You can select more than one option)',
  wt7_4:'A. Mutual Fund',
  wt7_5:'B. Fund of Funds',
  wt7_6:'C. Money Market Funds',
  wt7_7:'D. Balanced Fund',
  wt7_8:'E. Fixed Income Fund',
  wt7_9:'F. Equity Fund',
  wt7_10:'G. Index Fund',
  wt7_11:'H. Alternative Investment Fund',
  wt7_12:'Please state your year(s) of investment experience in "Fund Product(s)"：',
  wt7_13:'A. Less than 1 year',
  wt7_14:'B. 1 year to 3 years',
  wt7_15:'C. 3 years to 8 years',
  wt7_16:'D. More than 8 years',

  wt8_1:'A. YES',
  wt8_2:'B. NO',
  wt8_3:'If so, have you ever invested in the following "Bond Types"? (You can select more than one option)',
  wt8_4:'A. Sovereign Bond',
  wt8_5:'B. Corporate Bond',
  wt8_6:'C. Quasi Sovereign Bond',
  wt8_7:'D. Covered Bond',
  wt8_8:'E. High Yield Bond',
  wt8_9:'Please state your year(s) of investment experience in "Bond Product(s)"：',
  wt8_10:'A. Less than 1 year',
  wt8_11:'B. 1 year to 3 years',
  wt8_12:'C. 3 years to 8 years',
  wt8_13:'D. More than 8 years',

  wt9_1:'A. YES',
  wt9_2:'B. NO',

  bz1:"Remarks #1 : ",
  bz1_1:"\"Vulnerable Client\"",
  bz1_2:"This includes Clients with a disability that may affect their investment decisions (i.e. visually impaired, hearing-impaired, speech-impaired, chronic serious illness, etc.) / elderly (aged 66 or above) / education level (Primary 6 or below) / limited financial means.",

  bz2:"Remarks #2: ",
  bz2_1:"\"Individual Professional Investor\"",
  bz2_2:"It is an Individual or Joint Account with a portfolio of not less than HKD8,000,000 or its equivalent in foreign currency (as at the relevant calculation date)",
  bz2_3:"(a) the portfolio in the individual's own account;",
  bz2_4:"(b) the investment portfolio of the individual and his associate in a joint account;",
  bz2_5:"(c) the portion of the individual's investment portfolio in a joint account with persons other than one or more of his associates;",
  bz2_6:"(d) the principal business at the relevant date was the portfolio of a corporation that held investments and was wholly owned by the individual at the relevant date;",
  bz2_7:"the portion of an Individual's investment portfolio in a Joint Account with one or more persons other than its associates is",
  bz2_8:"(a) the individual's share of the portfolio as specified in a written agreement among the account holders; or",
  bz2_9:"(b) in the absence of an agreement referred to in paragraph B(a), an equal share of the portfolio.",

  next:"Continue",
  red_ts1:"Please complete the ( Red Wordings / Red Frame ) section",
  red_ts2:'If you are an "Investment Funds Client", the Questionnaire has been completed as you are not classified as an "Individual Professional Investor" and therefore you are not eligible to subscribe for "Investment Funds Product".',

  pj1:'Conservative',
  pj1_1:'Clients with a "Conservative" rating are only suitable to invest in financial investment products with "Lower Risk".',
  pj1_2:'"Conservative" Clients are generally willing to take a lower level of investment risk and accept lower investment returns. At the same time, Clients must understand that the investment value of the product may be much lower than the initial investment amount. "Conservative" Clients have equipped with limited or no relevant knowledge and/or experience in financial investment.',
  
  pj2:'Moderate',
  pj2_1:'Clients with a "Moderate" rating are only suitable to invest in financial investment products with "Lower to Medium Risk".',
  pj2_2:'"Moderate" Clients are generally willing to accept higher risk investment products than Low Risk in order to obtain higher returns than bank deposit interest rates to hedge against inflation. At the same time, Clients must understand that the investment value of the product may be much lower than the initial investment amount. "Moderate" Clients usually have some knowledges and/or experiences in financial investment.',

  pj3:'Balanced',
  pj3_1:'Clients with a "Balanced" rating are only suitable to invest in financial investment products with "Medium Risk".',
  pj3_2:'"Balanced" Clients are generally willing to take moderate investment risk to obtain investment returns comparable to Global Securities Market Indices. At the same time, Clients must understand that the investment value of the product may be much lower than the initial investment amount. "Balanced" Clients usually have reasonable relevant knowledges and/or experiences in financial investment.',

  pj4:'Growth',
  pj4_1:'Clients with a "Growth" rating are only suitable to invest in financial investment products with "Medium to High Risk".',
  pj4_2:'"Growth" Clients are generally willing to take moderate and high levels of investment risk to obtain higher returns than Global Securities Market Indices. At the same time, Clients must understand that the investment value of the product may be much lower than the initial investment amount. "Growth" Clients usually have the considerable financial investment knowledge and/or experience, and/or have sound financial strength to withstand moderate to high risk investment losses.',

  pj5:'Aggressive',
  pj5_1:'Clients with an "Aggressive" rating are only suitable to invest in financial investment products with "High Risk".',
  pj5_2:'"Aggressive" Clients are generally willing to take a fairly high level of investment risk in order to obtain investment returns that are significantly higher than Global Securities Market Indices. At the same time, Clients must understand that the investment value of the product may fall substantially below the initial investment amount. Most of "Aggressive" Clients have specialized investment knowledge and/or experiences, particularly in high-risk, complex / sophisticatedly structured or leveraged investment products, and have sound and/or strong financial strength to withstand the loss of high-risk investments.',

  title1:'Investment Orientation Questionnaire',
  title2:'More Ranking',
  tj2_1:'Questionnaire Result',
  tj2_2:'The result of your \"Client Investment Orientation Questionnaire\" is: ',
  tj2_3:'Choose other bond',
  tj2_4:'Choose other fund',

  tj2_5:'Back',
  tj2_6:'Confirm',
  
  tj2_7:'CLIENT INVESTMENT ORIENTATION QUESTIONNAIRE',
  tj2_8:'We have received your Investment Orientation Questionnaire',

  jjmz1:'Important Notes and Disclaimers',
  jjmz2:'Important Notes',
  jjmz3:'Investment in Fund Products involves significant risk and investors may not get back ( in part or in full ) the amount originally invested. It is not possible to fully disclose the risks associated with the Fund Products in which you invest. Prior to making an investment decision, you should read the offering documents of the relevant Investment Fund Products carefully to ensure that you fully understand the nature of the Investment Fund Products and the risks associated with them, and that you are willing to accept such risks, and you are advised to seek professional investment advice from independent Third Party(ies).\n\nBefore deciding to invest in the relevant Investment Funds, you must carefully consider the consequences of taxes, legal requirements and any exchange control requirements that you ( or your represented Company ) may be subject to under the law in relation to the purchase, sale, subscription, holding, conversion or disposal of holdings in the relevant Investment Fund Products in accordance with your citizenship, residence or domicile ( or the country / jurisdiction in which your represented Company is incorporated ).\n\nThe returns of Investment Funds are calculated in their base currency. If the currency of your home country / jurisdiction is different from the base currency or reference currency of the Investment Fund, changes in the exchange rate may increase or decrease your investment returns.',
  jjmz4:'Disclaimers',
  jjmz5:'The Investment Fund Products listed in this App may not be available in all countries / jurisdictions. Only persons permitted by applicable law to access the information of this App and/or accept the services and Investment Products mentioned in this disclaimer. Persons accessing this disclaimer must ensure that they are aware of and comply with the applicable restrictions and are responsible for verifying whether they are permitted to browse this App and/or use the Services under the laws of their country / jurisdiction. The information provided in this App is intended for use and/or browsing by residents of the Hong Kong Special Administrative Region.\n\nThe Investment Fund Products information on this App is for general reference only and is provided on an "as is" basis. QMIS Securities does not give any warranty as to such information and may change such information at any time without prior notice.\n\nThe information provided in this App should not be regarded as an offer to sell or a solicitation of an offer to sell or a solicitation of a subscription in respect of any Investment Fund Products and services in any country / jurisdiction, or as an opinion or recommendation to any Third Party. Persons accessing this App should consider their own financial situation, risk tolerance and are advised to seek independent Third Party professional investment advice prior to making relevant investment decisions.\n\nAll materials provided in this App are protected by copyright. The adaptation, reproduction, distribution or provision of the information contained in this App for commercial or public purposes is strictly prohibited only with the written approval of QMIS Securities.\n\nIf you use hyperlinks to other Websites or other sources of information, you do so at your own risk. QMIS Securities is not responsible for the accuracy, compliance or suitability of the information and content provided on Websites that may be linked to this App, nor does it guarantee that the information provided by Third Parties is protected.\n\nYou should note that any Fund Product quote information provided by this App is not real-time quote information, all quotes are subject to prevailing market conditions, and the relevant terms are subject to change and subject to the final offering documents. These quotations do not reflect the true subscription price or redemption price of the Investment Fund Products, and all quotes are subject to the final quotation of the Fund House.\n\nThe information on Investment Fund Products provided by this App is subject to the terms and conditions contained in its offering documents ( including but not limited to its term summary, Fund prospectus, information leaflet and all other relevant offering documents and materials ). You should read the offering documents of all relevant Investment Fund Products carefully prior to making an investment decision. Any sale or application for subscription of any Investment Fund Products through QMIS Securities is subject to the final decision of QMIS Securities and is subject to the terms and conditions of Investment Fund Services of any other country / jurisdiction as updated by QMIS Securities from time to time.',

  zjmz1:'Important Notes and Disclaimers',
  zjmz2:'Important Notes',
  zjmz3:'Investment in Bond Products involves significant risk and investors may not get back ( in part or in full ) the amount originally invested. It is not possible to fully disclose the risks associated with the Bond Products in which you invest. Prior to making an investment decision, you should read the offering documents of the relevant Investment Bond Products carefully to ensure that you fully understand the nature of the Investment Bond Products and the risks associated with them, and that you are willing to accept such risks, and you are advised to seek professional investment advice from independent Third Party(ies).\n\nBefore deciding to invest in the relevant Investment Bonds, you must carefully consider the consequences of taxes, legal requirements and any exchange control requirements that you ( or your represented Company ) may be subject to under the law in relation to the purchase, sale, subscription, holding, conversion or disposal of holdings in the relevant Investment Bond Products in accordance with your citizenship, residence or domicile ( or the country / jurisdiction in which your represented Company is incorporated ).\n\nThe returns of Investment Bonds are calculated in their base currency. If the currency of your home country / jurisdiction is different from the base currency or reference currency of the Investment Bonds, changes in the exchange rate may increase or decrease your investment returns.',
  zjmz4:'Disclaimers',
  zjmz5:'The Investment Bond Products listed in this App may not be available in all countries / jurisdictions. Only persons permitted by applicable law to access the information of this App and/or accept the services and Investment Products mentioned in this disclaimer. Persons accessing this disclaimer must ensure that they are aware of and comply with the applicable restrictions and are responsible for verifying whether they are permitted to browse this App and/or use the Services under the laws of their country / jurisdiction. The information provided in this App is intended for use and/or browsing by residents of the Hong Kong Special Administrative Region.\n\nThe Investment Bond Products information on this App is for general reference only and is provided on an "as is" basis. QMIS Securities does not give any warranty as to such information and may change such information at any time without prior notice.\n\nThe information provided in this App should not be regarded as an offer to sell or a solicitation of an offer to sell or a solicitation of a subscription in respect of any Investment Bond Products and services in any country / jurisdiction, or as an opinion or recommendation to any Third Party. Persons accessing this App should consider their own financial situation, risk tolerance and are advised to seek independent Third Party professional investment advice prior to making relevant investment decisions.\n\nAll materials provided in this App are protected by copyright. The adaptation, reproduction, distribution or provision of the information contained in this App for commercial or public purposes is strictly prohibited only with the written approval of QMIS Securities.\n\nIf you use hyperlinks to other Websites or other sources of information, you do so at your own risk. QMIS Securities is not responsible for the accuracy, compliance or suitability of the information and content provided on Websites that may be linked to this App, nor does it guarantee that the information provided by Third Parties is protected.\n\nYou should note that any Bond Product quote information provided by this App is not real-time quote information, all quotes are subject to prevailing market conditions, and the relevant terms are subject to change and subject to the final offering documents. These quotations do not reflect the true subscription price or redemption price of the Investment Bond Products, and all quotes are subject to the final quotation of the Bond Product Provider.\n\nThe information on Investment Bond Products provided by this App is subject to the terms and conditions contained in its offering documents ( including but not limited to its term summary, Bond Product documents, information leaflet and all other relevant offering documents and materials ). You should read the offering documents of all relevant Investment Bond Products carefully prior to making an investment decision. Any sale or application for subscription of any Investment Bond Products through QMIS Securities is subject to the final decision of QMIS Securities and is subject to the terms and conditions of Investment Bond Services of any other country / jurisdiction as updated by QMIS Securities from time to time.',

  hide_1:'Indicative Price：',
  hide_2:'Min Holding Amount：',
  hide_3:'Dividend Option：',
  hide_4:'3 Yrs Risk Return Ratio：',
  hide_5:'Last 3 Mths Returns：',
  hide_6:'Admission Amount：',
  hide_7:'Min Redemption Amount：',
  hide_8:'Dividend Frequency：',
  hide_9:'Sharpe Ratio：',
  hide_10:'Last 1 Mth Returns：',
  hide_11:'Sub Investment Amount：',
  hide_12:'Complex Product：',
  hide_13:'Estimated Coupon Rate：',
  hide_14:'Year-to-Date Returns：',
  hide_15:'Management Fee：',
  hide_16:'Subscription Frequency：',
  hide_17:'SFC Authorized Product：',
  hide_18:'Valuation Date：',

  bond_1:'Indicative Ask Price：',
  bond_2:'Ask Yield To Maturity：',
  bond_3:'Professional Investor：',
  bond_4:'Issuing Institution：',
  bond_5:'Indicative Bid Price：',
  bond_6:'Bid Yield To Maturity：',
  bond_7:'Complex Product：',
  bond_8:'Redeemable：',
  bond_9:'Admission Amount：',
  bond_10:'Credit Rating：',
  bond_11:'Issue Date：',
  bond_12:'Valuation Date：',
  bond_13:'Nominal Value：',
  bond_14:'Remaining Period：',

  khmc_wq:'Client Name：',
  zhhm_wq:'Account Number：',
  dlsj_wq:'Last Logon：',

  wq_ts1:'Prior to trading investment products ( Funds / Bonds ), QMIS Securities needs to assess whether your investment orientation analysis and the relative suitability rating of the product are suitable for you to subscribe. ',
  wq_ts2:'This questionnaire consists of 9 Questions and it takes about 5 minutes to complete',
  sign_off:'Logout',
}
export default lang;



// WEBPACK FOOTER //
// ./src/assets/eng.js